<div class="divHome" style="padding-bottom: 0px !important">
  <div class="header-container">
    <h1>Programación de Personal de Campo</h1>
    <div class="location-container" *ngIf="location">
      <i-tabler name="map-pin"></i-tabler>
      <h1>{{ location | titlecase }}</h1>
    </div>
  </div>

  <div *ngIf="loading" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading" class="divButtons">
    <mat-form-field class="buttonFilterFecha">
      <mat-label>FECHA</mat-label>

      <mat-datepicker-toggle
        matSuffix
        [for]="rangePicker"
      ></mat-datepicker-toggle>

      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate placeholder="Inicio" [(ngModel)]="startDate" />
        <input matEndDate placeholder="Fin" [(ngModel)]="endDate" />
      </mat-date-range-input>

      <mat-date-range-picker #rangePicker>
        <mat-date-range-picker-actions>
          <button mat-button matDateRangePickerCancel>Cancel</button>
          <button
            style="background-color: rgb(184, 69, 18)"
            mat-raised-button
            color="primary"
            (click)="onApplyRangeSelectedFile()"
            matDateRangePickerApply
          >
            Filtrar
          </button>

          <button
            mat-button
            matDateRangePickerCancel
            (click)="cleanDateSelected()"
          >
            Limpiar
          </button>
          <!-- <mat-icon style="color:rgb(96, 96, 96);font-size: 1rem; width: 100%;" (click)="cleanDateSelected()" >close</mat-icon> -->
        </mat-date-range-picker-actions>
      </mat-date-range-picker>
    </mat-form-field>

    <div class="divInputSearchContainer">
      <mat-form-field appearance="outline" class="divInputSearch">
        <input
          matInput
          [(ngModel)]="searchValue"
          placeholder="Buscar"
          (ngModelChange)="applyFilterSelect()"
        />
      </mat-form-field>
    </div>

    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>RUTAS</mat-label>
      <mat-select
        [(value)]="selectedRoutes"
        (selectionChange)="applyFilterSelect()"
        (openedChange)="onRoutesDropdownOpened($event)"
        panelClass="custom-filter-select-panel"
        multiple
        #selectRoutes
      >
        <mat-select-trigger>
          <span *ngIf="selectedRoutes && selectedRoutes.length > 0">
            {{ selectedRoutes[0] }}
            <span
              *ngIf="selectedRoutes && selectedRoutes.length > 1"
              class="trigger-extra-count"
            >
              (+{{ selectedRoutes.length - 1 }})
            </span>
          </span>
          <span
            *ngIf="!selectedRoutes || selectedRoutes.length === 0"
            class="select-trigger-placeholder"
          >
            Seleccionar
          </span>
        </mat-select-trigger>

        <div
          class="select-search-header"
          (click)="$event.stopPropagation()"
          (keydown)="onRouteSearchKeydown($event, selectRoutes)"
        >
          <div class="select-search-box">
            <i-tabler name="search" class="search-box-icon"></i-tabler>
            <input
              id="search-route-input"
              type="text"
              class="select-search-input"
              placeholder="Buscar ruta..."
              [ngModel]="searchRouteQuery"
              (ngModelChange)="onSearchRoute($event)"
              (click)="$event.stopPropagation()"
              autocomplete="off"
            />
            <button
              *ngIf="searchRouteQuery"
              type="button"
              class="select-search-clear-btn"
              (click)="clearSearchRoute($event)"
              title="Limpiar búsqueda"
            >
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
        </div>

        <mat-option
          *ngIf="selectedRoutes && selectedRoutes.length > 0"
          [value]="null"
          class="option-no-select"
          (click)="clearSelectedRoutes($event)"
        >
          Limpiar selección
        </mat-option>

        <mat-option
          *ngFor="let productRoute of availableProductRoutes"
          [value]="productRoute"
          [hidden]="!isRouteVisible(productRoute)"
        >
          {{ productRoute }}
        </mat-option>

        <div *ngIf="!hasVisibleRoutes()" class="select-empty-message">
          No se encontraron coincidencias para "{{ searchRouteQuery }}"
        </div>
      </mat-select>

      <button
        *ngIf="selectedRoutes && selectedRoutes.length > 0"
        mat-icon-button
        matSuffix
        type="button"
        class="filter-field-clear-btn"
        (click)="clearSelectedRoutes($event)"
        title="Limpiar filtro de rutas"
      >
        <i-tabler name="x"></i-tabler>
      </button>
    </mat-form-field>
  </div>

  <div style="height: 48rem" class="mat-elevation-z8" [hidden]="isLoading">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="comunidad" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >COMUNIDAD</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">
          <mat-select
            [(ngModel)]="element.comunidad"
            multiple
            placeholder="Seleccionar"
            (ngModelChange)="
              saveComunidadByProduct(
                element,
                element.itineraryId,
                element.objProducto?.id,
                element.comunidad
              )
            "
          >
            <mat-option
              *ngFor="let comunidad of comunidades"
              [value]="comunidad"
              >{{ comunidad }}</mat-option
            >
          </mat-select>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaInicioProducto" sticky>
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyleMedium"
          mat-sort-header
        >
          FECHA INICIO
        </mat-header-cell>
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">
          {{ element?.fechaInicioProducto }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fecha-fin" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >FECHA FIN</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">{{
          element?.fechaFinProducto
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="file" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >FILE</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element"
          >{{ element?.fileNumber
          }}{{ element.fileExtend ? " " + element.fileExtend : "" }}</mat-cell
        >
      </ng-container>

      <ng-container matColumnDef="tipoFile" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >TIPO PRODUCTO</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">
          <mat-chip-list>
            <mat-chip
              [color]="element.isSSFFPadre ? 'primary' : 'accent'"
              selected
              matTooltipPosition="right"
              [matTooltip]="
                element.isSSFFPadre
                  ? getInfoSSFF(element.filesHijos, element.TC)
                  : getTCInfo(element.TC)
              "
              matTooltipClass="mat-tooltip-multiline"
            >
              {{ element.isSSFFPadre ? "SSFF" : "PRIVADO" }}
            </mat-chip>
          </mat-chip-list>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nameClient" sticky>
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyleMedium"
          mat-sort-header
          >CLIENTE</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">{{
          !element.isSSFFPadre ? element?.nameClient : "-"
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="fileDisplayState" sticky>
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyleMedium"
          mat-sort-header
          >ESTADO FILE</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">{{
          element.fileDisplayState
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nombreItinerario" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >GRUPO</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">{{
          !element.isSSFFPadre ? element?.nombreItinerario : "-"
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="passengers" sticky>
        <mat-header-cell class="bodyStyleMedium" *matHeaderCellDef>
          Pasajeros
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          <div class="columnPassenger">
            <mat-icon
              (click)="openDialogPasajeros(row.lstPaX)"
              [matBadge]="(row?.pax?.length || 0) + (row?.TC?.length || 0)"
            >
              groups_2
            </mat-icon>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pax&tc" sticky>
        <mat-header-cell class="bodyStyleMedium" *matHeaderCellDef>
          PAX & TC
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="bodyStyleMedium">
          <div class="divPassenger">
            <p>Pasajeros: {{ row?.pax?.length || 0 }}</p>
            <p>TC: {{ row?.TC?.length || 0 }}</p>
          </div>
        </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="cantidadTC" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >TC</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">{{
          element?.TC?.length || 0
        }}</mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="ruta" sticky>
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >RUTA</mat-header-cell
        >
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">{{
          element?.objProducto?.nombre ? element?.objProducto.nombre : "OTROS"
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="tc">
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyleMedium"
          mat-sort-header
        >
          TC
        </mat-header-cell>
        <mat-cell class="bodyStyleMedium" *matCellDef="let element">
          {{ element?.tc }}
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="porteador"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >PORTEADOR</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosPorteador.length > 0; else dash"
          >
            <button
              mat-icon-button
              [matTooltip]="getCategoryTooltip(element.serviciosPorteador, element.serviciosPorteadorUnique)"
              (click)="
                openDialog(
                  i,
                  element,
                  'PORTEADOR',
                  element.serviciosPorteador,
                  element.serviciosPorteadorUnique,
                  element.comunidad
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosPorteador,
                    element.serviciosPorteadorUnique
                  )
                }}"
                >person</mat-icon
              >

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosPorteadorUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
            <span
              class="subtle-os-pill"
              *ngIf="countServiciosConOS(element.serviciosPorteador) > 0"
            >
              {{ countServiciosConOS(element.serviciosPorteador) }} con OS
            </span>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="porteador-extra"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >PORTEADOR EXTRA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosPorteadorExtra.length > 0; else dash"
          >
            <button
              mat-icon-button
              [matTooltip]="getCategoryTooltip(element.serviciosPorteadorExtra, element.serviciosPorteadorExtraUnique)"
              (click)="
                openDialog(
                  i,
                  element,
                  'PORTEADOREXTRA',
                  element.serviciosPorteadorExtra,
                  element.serviciosPorteadorExtraUnique,
                  element.comunidad
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosPorteadorExtra,
                    element.serviciosPorteadorExtraUnique
                  )
                }}"
                >person</mat-icon
              >
              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosPorteadorExtraUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
            <span
              class="subtle-os-pill"
              *ngIf="countServiciosConOS(element.serviciosPorteadorExtra) > 0"
            >
              {{ countServiciosConOS(element.serviciosPorteadorExtra) }} con OS
            </span>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="trp"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >TRP EXCESO PESO ALIM</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosTransporte.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'TRANSPORTE',
                  element.serviciosTransporte,
                  element.serviciosTransporteUnique,
                  element.comunidad
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosTransporte,
                    element.serviciosTransporteUnique
                  )
                }}"
                >person</mat-icon
              >
              <mat-icon>people</mat-icon>
              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosTransporteUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <!--         <ng-container matColumnDef="fecha-liberacion">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">FECHA LIBERACIÓN</mat-header-cell>
            <mat-cell  class="bodyStyleMedium"*matCellDef="let element">{{ element?.fechaLiberacion}}</mat-cell>
          </ng-container> -->

      <!--         <ng-container matColumnDef="carpero">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">CARPERO/BAÑERO</mat-header-cell>
            <mat-cell  class="bodyStyleMedium"*matCellDef="let element;let i=index">
              <ng-container *ngIf="element.serviciosCarperoBanero.length>0; else dash">
                <button mat-icon-button
                  (click)="openDialog(i,element,'CARPERO',element.serviciosCarperoBanero,element.serviciosCarperoBaneroUnique)">
                  <mat-icon class="checkin"
                    matBadge={{calculateTotalServices_(element.serviciosCarperoBanero,element.serviciosCarperoBaneroUnique)}}>person</mat-icon>
                  <mat-icon matBadge={{calculateTotalServices(element.serviciosCarperoBaneroUnique)}}
                    class="icon-color badgeStyle">people</mat-icon>
                </button>
              </ng-container>
              <ng-template #dash>
                -
              </ng-template>
            </mat-cell>
          </ng-container> -->

      <!--         <ng-container matColumnDef="carpero-extra">
            <mat-header-cell *matHeaderCellDef class="headerStyleMedium">CARPERO/BAÑERO EXTRA</mat-header-cell>
            <mat-cell  class="bodyStyleMedium"*matCellDef="let element;let i=index">
              <ng-container *ngIf="element.serviciosCarperoBaneroExtra.length>0; else dash">
                <button mat-icon-button
                  (click)="openDialog(i,element,'CARPEROEXTRA',element.serviciosCarperoBaneroExtra,element.serviciosCarperoBaneroExtraUnique)">
                  <mat-icon class="checkin"
                    matBadge={{calculateTotalServices_(element.serviciosCarperoBaneroExtra,element.serviciosCarperoBaneroExtraUnique)}}>person</mat-icon>
                  <mat-icon matBadge={{calculateTotalServices(element.serviciosCarperoBaneroExtraUnique)}}
                    class="icon-color badgeStyle">people</mat-icon>
                </button>
              </ng-container>
              <ng-template #dash>
                -
              </ng-template>
            </mat-cell>
          </ng-container> -->

      <ng-container matColumnDef="jefe-arriero">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >JEFE ARRIERO</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosJefeArriero.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'JEFEARRIERO',
                  element.serviciosJefeArriero,
                  element.serviciosJefeArrieroUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosJefeArriero,
                    element.serviciosJefeArrieroUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosJefeArrieroUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cocinero">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >COCINERO</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let rowData; let i = index"
        >
          <ng-container *ngIf="rowData.serviciosCocinero.length > 0; else dash">
            <button
              mat-icon-button
              [matTooltip]="getCategoryTooltip(rowData.serviciosCocinero, rowData.serviciosCocineroUnique)"
              (click)="
                openDialog(
                  i,
                  rowData,
                  'COCINERO',
                  rowData.serviciosCocinero,
                  rowData.serviciosCocineroUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    rowData.serviciosCocinero,
                    rowData.serviciosCocineroUnique
                  )
                }}"
                >person</mat-icon
              >
              <mat-icon
                matBadge="{{
                  calculateTotalServices(rowData.serviciosCocineroUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
            <span
              class="subtle-os-pill"
              *ngIf="countServiciosConOS(rowData.serviciosCocinero) > 0"
            >
              {{ countServiciosConOS(rowData.serviciosCocinero) }} con OS
            </span>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="asistente-cocina">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ASISTENTE COCINA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosAsisCocina.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ASISTENTECOCINA',
                  element.serviciosAsisCocina,
                  element.serviciosAsisCocinaUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosAsisCocina,
                    element.serviciosAsisCocinaUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosAsisCocinaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="guia">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >GUIA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container *ngIf="element.serviciosGuia.length > 0; else dash">
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'GUIA',
                  element.serviciosGuia,
                  element.serviciosGuiaUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosGuia,
                    element.serviciosGuiaUnique
                  )
                }}"
                >person</mat-icon
              >

              <mat-icon
                matBadge="{{
                  calculateTotalServicesGUIA(element.serviciosGuiaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="arrieros"
        *ngIf="location?.toLowerCase() === 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ARRIEROS</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container *ngIf="element.serviciosArrieros.length > 0; else dash">
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ARRIERO',
                  element.serviciosArrieros,
                  element.serviciosArrierosUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosArrieros,
                    element.serviciosArrierosUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosArrierosUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="arriero-carga"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ARRIERO CARGA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosArrieroCarga.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ARRIEROCARGA',
                  element.serviciosArrieroCarga,
                  element.serviciosArrieroCargaUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosArrieroCarga,
                    element.serviciosArrieroCargaUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosArrieroCargaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="arriero-silla"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ARRIERO SILLA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosArrieroSilla.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ARRIEROSILLA',
                  element.serviciosArrieroSilla,
                  element.serviciosArrieroSillaUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosArrieroSilla,
                    element.serviciosArrieroSillaUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->
              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosArrieroSillaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="acemila"
        *ngIf="location?.toLowerCase() === 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ACEMILA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container *ngIf="element.serviciosAcemila.length > 0; else dash">
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ACEMILA',
                  element.serviciosAcemila,
                  element.serviciosAcemilaUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosAcemila,
                    element.serviciosAcemilaUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosAcemilaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acemila-carga">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ACEMILA CARGA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosAcemilaCarga.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ACEMILACARGA',
                  element.serviciosAcemilaCarga,
                  element.serviciosAcemilaCargaUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosAcemilaCarga,
                    element.serviciosAcemilaCargaUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosAcemilaCargaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acemila-silla">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ACEMILA SILLA</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosAcemilaSilla.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ACEMILASILLA',
                  element.serviciosAcemilaSilla,
                  element.serviciosAcemilaSillaUnique
                )
              "
            >
              <mat-icon
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosAcemilaSilla,
                    element.serviciosAcemilaSillaUnique
                  )
                }}"
                >person</mat-icon
              >

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosAcemilaSillaUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="carpero-banero">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium">{{
          this.location?.toLowerCase() === "huaraz"
            ? "BAÑERO"
            : "CARPERO/BAÑERO"
        }}</mat-header-cell>
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosCarperoBanero.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  this.location?.toLowerCase() === 'huaraz'
                    ? 'BAÑERO'
                    : 'CARPEROBANERO',
                  element.serviciosCarperoBanero,
                  element.serviciosCarperoBaneroUnique
                )
              "
            >
              <mat-icon
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosCarperoBanero,
                    element.serviciosCarperoBaneroUnique
                  )
                }}"
                >person</mat-icon
              >

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosCarperoBaneroUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="asist-picnic"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >ASISTENTE PICNIC</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container
            *ngIf="element.serviciosAsisPicnic.length > 0; else dash"
          >
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'ASISTENTEDEPICNIC',
                  element.serviciosAsisPicnic,
                  element.serviciosAsisPicnicUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosAsisPicnic,
                    element.serviciosAsisPicnicUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosAsisPicnicUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="chofer">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >CHOFER</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container *ngIf="element.serviciosChofer.length > 0; else dash">
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'CHOFER',
                  element.serviciosChofer,
                  element.serviciosChoferUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosChofer,
                    element.serviciosChoferUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->
              <!-- <span> | </span> -->
              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosChoferUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="doctor"
        *ngIf="location?.toLowerCase() !== 'huaraz'"
      >
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >DOCTOR</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container *ngIf="element.serviciosDoctor.length > 0; else dash">
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'DOCTOR',
                  element.serviciosDoctor,
                  element.serviciosDoctorUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosDoctor,
                    element.serviciosDoctorUnique
                  )
                }}"
                >person</mat-icon
              >
              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosDoctorUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="comfort">
        <mat-header-cell *matHeaderCellDef class="headerStyleMedium"
          >COMFORT TREK</mat-header-cell
        >
        <mat-cell
          class="bodyStyleMedium"
          *matCellDef="let element; let i = index"
        >
          <ng-container *ngIf="element.serviciosComfort.length > 0; else dash">
            <button
              mat-icon-button
              (click)="
                openDialog(
                  i,
                  element,
                  'COMFORT',
                  element.serviciosComfort,
                  element.serviciosComfortUnique
                )
              "
            >
              <mat-icon
                class="checkin"
                matBadge="{{
                  calculateTotalServices_(
                    element.serviciosComfort,
                    element.serviciosComfortUnique
                  )
                }}"
                >person</mat-icon
              >
              <!-- <mat-icon>people</mat-icon> -->

              <mat-icon
                matBadge="{{
                  calculateTotalServices(element.serviciosComfortUnique)
                }}"
                class="icon-color badgeStyle"
                >people</mat-icon
              >
            </button>
          </ng-container>
          <ng-template #dash> - </ng-template>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="
          this.location?.toLowerCase() === 'huaraz'
            ? this.huarazDisplayedColumns
            : this.cuscoDisplayedColumns;
          sticky: true
        "
      ></mat-header-row>
      <mat-row
        *matRowDef="
          let row;
          columns: this.location?.toLowerCase() === 'huaraz'
            ? this.huarazDisplayedColumns
            : this.cuscoDisplayedColumns
        "
      ></mat-row>
    </mat-table>
  </div>

  <div [hidden]="loading">
    <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons>
    </mat-paginator>
  </div>

  <div class="container-leyenda">
    <div
      *ngIf="!loading && location?.toLowerCase() !== 'huaraz'"
      class="container"
    >
      <table class="leyenda">
        <tr>
          <th colspan="5" class="title">PORTEADORES DISPONIBLES A LA FECHA</th>
        </tr>
        <tr>
          <th>CAMICANCHA</th>
          <th>HUILLOC</th>
          <th>LAMAY</th>
          <th>SOCMA</th>
          <th style="background-color: rgb(189, 189, 189)">TOTAL</th>
        </tr>
        <tr>
          <td class="centered-cell">
            <div>
              <span>{{ this.providersByComunidad["CAMICANCHA"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.providersByComunidad["HUILLOC"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.providersByComunidad["LAMAY"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.providersByComunidad["SOCMA"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.porteadorDataFilter?.length }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div
      *ngIf="!loading && location?.toLowerCase() !== 'huaraz'"
      class="container"
    >
      <table class="leyenda">
        <tr>
          <th colspan="5" class="title">COCINEROS DISPONIBLES A LA FECHA</th>
        </tr>
        <tr>
          <th>CAMICANCHA</th>
          <th>HUILLOC</th>
          <th>LAMAY</th>
          <th>SOCMA</th>
          <th style="background-color: rgb(189, 189, 189)">TOTAL</th>
        </tr>
        <tr>
          <td class="centered-cell">
            <div>
              <span>{{ this.cocinerosByComunidad["CAMICANCHA"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.cocinerosByComunidad["HUILLOC"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.cocinerosByComunidad["LAMAY"]?.length }}</span>
            </div>
          </td>
          <td class="centered-cell">
            <div>
              <span>{{ this.cocinerosByComunidad["SOCMA"]?.length }}</span>
            </div>
          </td>

          <td class="centered-cell">
            <div>
              <span>{{ this.cocineroDataFilter?.length }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div
      *ngIf="!loading"
      class="container"
      style="display: flex; justify-content: start"
    >
      <table class="leyenda">
        <td>
          <p><b>LEYENDA:</b></p>
          <ul>
            <li style="display: flex; align-items: center; margin-bottom: 2px">
              <mat-icon style="color: &quot;#36b036&quot;">person</mat-icon>
              Proveedores asignados
            </li>

            <li style="display: flex; align-items: center">
              <mat-icon style="color: &quot;#E95A1A&quot;">people</mat-icon
              >Total Proveedores
            </li>
          </ul>
        </td>
      </table>
    </div>
  </div>
</div>
